import { getApiClient } from '@src/shared/types/api-client'
import { AuditLogEntry, AuditLogFilters } from '@src/tools/key-vault/types/KeyVault'
import { useQuery } from '@tanstack/react-query'

const SCOPE = 'keyvault-audit'
const LIST = 'list'

const keysFactory = {
  all: () => [{ scope: SCOPE }] as const,
  list: (filters: AuditLogFilters) => [{ scope: SCOPE, entity: LIST, ...filters }] as const,
}

async function getAuditLogs({
  queryKey: [filters],
}: {
  queryKey: readonly [AuditLogFilters & { scope: string; entity: string }]
}): Promise<AuditLogEntry[]> {
  const { scope: _scope, entity: _entity, ...filtersOnly } = filters
  const apiClient = getApiClient()
  const response = await apiClient.post<AuditLogEntry[]>('/KeyVaults/AuditLogs', filtersOnly)
  return response.data
}

export function useAuditLogs(filters: AuditLogFilters): [AuditLogEntry[], boolean] {
  const { data, isFetching } = useQuery({
    queryKey: keysFactory.list(filters),
    queryFn: getAuditLogs,
    placeholderData: [],
  })
  return [data ?? [], isFetching]
}
